
export function projectServiceFactory(i: any) {
  return i.get('ProjectService');
}

export const projectServiceProvider = {
  provide: 'ProjectService',
  useFactory: projectServiceFactory,
  deps: ['$injector']
};


export function modalServiceFactory(i: any) {
  return i.get('modalService');
}

export const modalServiceProvider = {
  provide: 'modalService',
  useFactory: modalServiceFactory,
  deps: ['$injector']
};

export function authenticationFactory(i: any) {
  return i.get('AuthenticationFactory');
}
export const authenticationServiceProvider = {
  provide: 'AuthenticationFactory',
  useFactory: authenticationFactory,
  deps: ['$injector']
};


export function monitoringStoreServiceFactory(i: any) {
  return i.get('MonitoringStoreService');
}

export const monitoringStoreServiceProvider = {
  provide: 'MonitoringStoreService',
  useFactory: monitoringStoreServiceFactory,
  deps: ['$injector']
};


export function configurationStoreServiceFactory(i: any) {
  return i.get('ConfigurationStoreService');
}

export const configurationStoreServiceProvider = {
  provide: 'ConfigurationStoreService',
  useFactory: configurationStoreServiceFactory,
  deps: ['$injector']
};

export function timeZoneFactory(i: any) {
  return i.get('TimeZoneFactory');
}
export const timeZoneServiceProvider = {
  provide: 'TimeZoneFactory',
  useFactory: timeZoneFactory,
  deps: ['$injector']
};

export function tripOverviewFactory(i: any) {
  return i.get('TripOverviewFactory');
}
export const tripOverviewServiceProvider = {
  provide: 'TripOverviewFactory',
  useFactory: tripOverviewFactory,
  deps: ['$injector']
};

export function sqiFactory(i: any) {
  return i.get('SqiFactory');
}
export const SqiServiceProvider = {
  provide: 'SqiFactory',
  useFactory: sqiFactory,
  deps: ['$injector']
};

export function zabbixOverviewFactory(i: any) {
  return i.get('ZabbixOverviewFactory');
}
export const zabbixOverviewServiceProvider = {
  provide: 'ZabbixOverviewFactory',
  useFactory: zabbixOverviewFactory,
  deps: ['$injector']
};

export function trainTypeServiceFactory(i: any) {
  return i.get('TrainTypeService');
}

export const trainTypeServiceProvider = {
  provide: 'TrainTypeService',
  useFactory: trainTypeServiceFactory,
  deps: ['$injector']
};

export function trainMaintainerServiceFactory(i: any) {
  return i.get('TrainMaintainerService');
}

export const trainMaintainerServiceProvider = {
  provide: 'TrainMaintainerService',
  useFactory: trainMaintainerServiceFactory,
  deps: ['$injector']
};


export function $rootScopeFactory(i: any) {
  return i.get('$rootScope');
}

export const $rootScopeProvider = {
  provide: '$rootScope',
  useFactory: $rootScopeFactory,
  deps: ['$injector']
};

export function filterStorageFactory(i: any) {
  return i.get('FilterStorage');
}

export const filterStorageProvider = {
  provide: 'FilterStorage',
  useFactory: filterStorageFactory,
  deps: ['$injector']
};

export function zabbixIssueFactory(i: any) {
  return i.get('ZabbixIssueFactory');
}
export const zabbixIssueProvider = {
  provide: 'ZabbixIssueFactory',
  useFactory: zabbixIssueFactory,
  deps: ['$injector']
};

export function trainScheduleExportFactory(i: any) {
  return i.get('TrainScheduleExportFactory');
}

export const trainScheduleExportServiceProvider = {
  provide: 'TrainScheduleExportFactory',
  useFactory: trainScheduleExportFactory,
  deps: ['$injector']
};

